import { Box } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./style.module.css";
import { useTheme } from "../../../context/themeContext";
import PrimaryHeader from "../components/purple-header";
import Header from "./components/header";
import GridResult from "./components/grid";
import ListResult from "./components/list";
import BlueHeader from "../components/blue-header";
import { useSelector } from "react-redux";
import useDiscover from "../../../hooks/useDiscover";
import useLocalStorageState from "../../../hooks/useLocalStorageState";
import useProtectedAuth from "../../../hooks/useProtectedAuth";
import { node_server } from "../../../constants";

const SearchResult = () => {
  useProtectedAuth();
  const { theme } = useTheme();
  const [tabOption, setTabOption] = useLocalStorageState("tabOption", "grid");
  const { searchType } = useSelector((state) => state.search);
  useDiscover();

  // it may be deleted
  useEffect(() => {
    const fetchKeywordSearch = async () => {
      const { data, error } = await fetch(`${node_server}/api/users/primary-skills`);

      if (error) console.log(error);
      // if (data)
      //   setSearchResults(
      //     data.map((item) => {
      //       return {
      //         profileImage: item.profile_image,
      //         nickname: item.nick_name,
      //         name: item.real_name,
      //         primaryImage: item.skill_cover_image,
      //         skill: item.description,
      //         user_id: item.user_id,
      //       };
      //     })
      //   );
    };

    const fetchCustomSearchResults = async () => {
      const { data, error } = await fetch(`${node_server}/api/users/types-skills`);

      if (error) console.log(error);
      // if (data)
      // setSearchResults(
      //   data.map((item) => {
      //     return {
      //       profileImage: item.profile_image,
      //       nickname: item.nick_name,
      //       name: item.real_name,
      //       primaryImage: item.skill_cover_image,
      //       skill: item.description,
      //       user_id: item.user_id,
      //     };
      //   })
      // );
    };

    if (searchType === "singleSearch") fetchKeywordSearch();
    if (searchType === "custom") fetchCustomSearchResults();
  }, []);

  const clickGridOption = () => {
    setTabOption("grid");
  };

  const clickListOption = () => {
    setTabOption("list");
  };

  return (
    <Box
      className={styles.result}
      sx={{
        bgcolor: theme.palette.lightgrey.lightgrey500,
        minHeight: "100vh",
        paddingBottom: "4rem",
      }}
    >
      <Box
        className={styles.container}
        sx={{
          width: {
            xs: "100%",
          },
        }}
      >
        <Box
          className={styles.topGradient}
          sx={{
            background:
              tabOption === "grid"
                ? `linear-gradient(180deg, #00B0F0 0%, rgba(41, 41, 41, 0.00) 100%)`
                : `linear-gradient(180deg, #8C20B3 0%, rgba(245, 242, 246, 0.00) 100%)`,
          }}
        >
          {tabOption === "grid" && <BlueHeader />}
          {tabOption === "list" && <PrimaryHeader />}
        </Box>
        <Header
          clickGridOption={clickGridOption}
          clickListOption={clickListOption}
          tabOption={tabOption}
        />

        {tabOption === "grid" && <GridResult />}
        {tabOption === "list" && <ListResult />}
      </Box>
    </Box>
  );
};

export default SearchResult;
